export function isBlank(v) {
  return v.trim() === "";
}
